import {takeEvery} from 'redux-saga/effects'
import {
  GET_EXAM_REPORT_ACCUMULATED_SHEET,
  GET_EXAM_REPORT_ANALYSIS_SECTION_WISE,
  GET_EXAM_REPORT_ANALYSIS_STUDENT_WISE,
  GET_EXAM_REPORT_COMBINED_TEST,
  GET_EXAM_REPORT_COMBINED_WEIGHTAGE,
  GET_EXAM_REPORT_CUMULATIVE_SECTION_WISE,
  GET_EXAM_REPORT_GPA_ANALYSIS,
  GET_EXAM_REPORT_GRADE_ANALYSIS,
  GET_EXAM_REPORT_GRADE_ANALYSIS_STUDENTS,
  GET_EXAM_REPORT_HOMEWORK_REPORTS,
  GET_EXAM_REPORT_MARKSHEET,
  GET_EXAM_REPORT_SECTION_WISE,
  GET_EXAM_REPORT_TEST_REPORTS,
  SEND_EXAM_REPORT_MARKSHEET,
} from 'setup/redux/Actions/ExamReport/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EXAM_REPORT_SECTION_WISE, fetchData)
  yield takeEvery(GET_EXAM_REPORT_ACCUMULATED_SHEET, fetchData)
  yield takeEvery(GET_EXAM_REPORT_COMBINED_TEST, fetchData)
  yield takeEvery(GET_EXAM_REPORT_GPA_ANALYSIS, fetchData)
  yield takeEvery(GET_EXAM_REPORT_COMBINED_WEIGHTAGE, fetchData)
  yield takeEvery(GET_EXAM_REPORT_MARKSHEET, fetchData)
  yield takeEvery(GET_EXAM_REPORT_CUMULATIVE_SECTION_WISE, fetchData)
  yield takeEvery(GET_EXAM_REPORT_ANALYSIS_STUDENT_WISE, fetchData)
  yield takeEvery(GET_EXAM_REPORT_ANALYSIS_SECTION_WISE, fetchData)
  yield takeEvery(GET_EXAM_REPORT_TEST_REPORTS, fetchData)
  yield takeEvery(GET_EXAM_REPORT_HOMEWORK_REPORTS, fetchData)
  yield takeEvery(GET_EXAM_REPORT_GRADE_ANALYSIS_STUDENTS, fetchData)
  yield takeEvery(GET_EXAM_REPORT_GRADE_ANALYSIS, fetchData)
  yield takeEvery(SEND_EXAM_REPORT_MARKSHEET, fetchData)
}

export default dataSaga
